import { useLanguageNamespaceLoader, useLocale } from '@gov-nx/core/service';
import type { BreadcrumbOption } from '@gov-nx/ui/web';
import { PageCode } from '../definitions/codes';

export const useProfileROSBreadcrumbs = (): {
	options: BreadcrumbOption[];
	isLoading: boolean;
} => {
	const code = PageCode['profil-ROS'];
	const { t } = useLocale(code);
	const translations = useLanguageNamespaceLoader(code);

	return {
		isLoading: translations.isLoading,
		options: [
			{ label: t('domu'), toPage: 'dashboard' },
			{ label: t('profil-ROS.drobeckova-navigace.profil') },
		],
	};
};
